import { clearVisiteOfflineCache, type OfflineStorage } from '@offertify/query';

/**
 * Web adapter for the shared offline cache port: a thin async wrapper around
 * window.localStorage. The shared @offertify/query package stays platform-
 * agnostic (mobile will inject AsyncStorage instead); the web app never lets the
 * persister touch localStorage directly.
 */
export const webOfflineStorage: OfflineStorage = {
  getItem: async (key) => localStorage.getItem(key),
  setItem: async (key, value) => {
    localStorage.setItem(key, value);
  },
  removeItem: async (key) => {
    localStorage.removeItem(key);
  },
};

/**
 * Purge every offline cache this app persists. Call on any session end or tenant
 * switch (logout, failed refresh, stop-impersonation) so tenant-scoped visite
 * data never lingers in localStorage for the next user of a shared browser.
 */
export async function clearWebOfflineCaches(): Promise<void> {
  await clearVisiteOfflineCache(webOfflineStorage);
}
